export const baseConfig = {
  BACKEND_URL: process.env.NEXT_PUBLIC_BACKEND_URL,
  GAS_PRICE_API: 'https://gasprice.poa.network/',
  NEXUS_MUTUAL_API: 'https://api.nexusmutual.io/',
  PROVIDER: process.env.NEXT_PUBLIC_PROVIDER,
  DEEPL_API_KEY: process.env.DEEPL_API_KEY,
  BLOCKNATIVE_API_KEY: process.env.BLOCKNATIVE_API_KEY,
  NEXUS_MUTUAL_KEY: process.env.NEXUS_MUTUAL_KEY
}
